import {PCIDSS_UNASSISTED} from './constants/public/psr.js';
import {getPsrLabel} from './index.js';

export const getRequest = (currentData, paymentCheckboxes) => ({
  origin: 'PUBLICPSRWEB',
  merchant: {
    mcc: currentData?.sector?.split('(')[1].substring(0, 4),
    businessSector: currentData.sector,
    industry: currentData.industry,
  },
  pciDss: currentData.pciDss === PCIDSS_UNASSISTED ? 'UNASSISTED' : 'ASSISTED',
  annualCardTurnover: {
    value: currentData.card_turn_over,
    currencyCode: 'GBP',
  },
  averageTransaction: {
    value: currentData.average_card_payment,
    currencyCode: 'GBP',
  },
  paymentChannels: {
    face: paymentCheckboxes.find((x) => x.name === 'FaceToFace')
      ?.paymentModeChecked,
    facePercentage: currentData.faceToFacePercentage || 0,
    online: paymentCheckboxes.find((x) => x.name === 'Online')
      ?.paymentModeChecked,
    moto: paymentCheckboxes.find((x) => x.name === 'OverThePhone')
      ?.paymentModeChecked,
  },
});

export const getQuotationPrice = (value, isApplicable) => {
  const result =
    value && isApplicable
      ? `£${value}`
      : getPsrLabel('cardPaymentServicesDetails.notApplicable');

  return result;
};

export const getQuotationPercent = (value) => {
  const result = value
    ? `${value}%`
    : getPsrLabel('cardPaymentServicesDetails.notApplicable');

  return result;
};

export const getTotalPercent = (value) => {
  const result = value
    ? `${value * 100}p`
    : getPsrLabel('cardPaymentServicesDetails.notApplicable');

  return result;
};

export const getCardRatePercent = (value) => {
  const result = value ? (value * 1000) / 100 : 0;

  return result;
};

export const getTotalCardRatePercent = (value, fee) => {
  const result = getCardRatePercent(value) + fee * 100;

  return result;
};

export const getPercent = (value) => {
  const result = value
    ? `${value}p`
    : getPsrLabel('cardPaymentServicesDetails.notApplicable');

  return result;
};
